import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import broadcastReducer from "./broadcast/broadcast.slice";
import menusSlice from "./menus/menus.slice";
import modalsSlice from "./modals/modals.slice";
import postEditingSlice from "./post-editing/post-editing.slice";
import { rootSaga } from "./root-saga";

function loadBroadcastState() {
	try {
		const saved = localStorage.getItem("broadcastState");
		return saved ? { broadcast: JSON.parse(saved) } : undefined;
	} catch {
		return undefined;
	}
}

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
	reducer: {
		broadcast: broadcastReducer,
		modals: modalsSlice.reducer,
		menus: menusSlice.reducer,
		postEditing: postEditingSlice.reducer,
	},
	preloadedState: loadBroadcastState(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			thunk: false,
			// The modal system deliberately stores onConfirm/onCancel callbacks
			// on `showModal`'s payload (see redux/modals/modals.types.ts) — that's
			// not accidental non-serializable state, so the checker is told to
			// leave this one path alone rather than disabling it store-wide.
			serializableCheck: {
				ignoredActions: ["modals/showModal"],
				ignoredPaths: ["modals.currentModal"],
			},
		}).concat(sagaMiddleware),
});

store.subscribe(() => {
	const { broadcast } = store.getState();
	try {
		if (broadcast.broadcastId) {
			localStorage.setItem("broadcastState", JSON.stringify(broadcast));
		} else {
			localStorage.removeItem("broadcastState");
		}
	} catch {}
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
